import React from 'react';
import { NotFound } from '../../components/NotFound';
import { useDocumentTitle } from '../../shared/use-document-title';
import styles from './NotFoundPage.css';

function NotFoundPage() {
    useDocumentTitle('Not found');

    return (
        <div className={styles.root}>
            <NotFound className={styles.body} />
        </div>
    );
}

export {
    NotFoundPage
};
